export enum RisingStarBadgeType {
  RISING_STAR = 'rising-star.svg',
}
